import { render, staticRenderFns } from "./Fraude.vue?vue&type=template&id=2a5ec223&scoped=true"
import script from "./Fraude.vue?vue&type=script&lang=js"
export * from "./Fraude.vue?vue&type=script&lang=js"
import style0 from "./Fraude.vue?vue&type=style&index=0&id=2a5ec223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ec223",
  null
  
)

export default component.exports